var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_36_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 28C6.686 28 4 30.686 4 34C4 37.314 6.686 40 10 40C13.314 40 16 37.314 16 34C16 30.686 13.314 28 10 28ZM10 36C8.898 36 8 35.102 8 34C8 32.898 8.898 32 10 32C11.102 32 12 32.898 12 34C12 35.102 11.102 36 10 36Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 26C13.3137 26 16 23.3137 16 20C16 16.6863 13.3137 14 10 14C6.68629 14 4 16.6863 4 20C4 23.3137 6.68629 26 10 26Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C6.686 0 4 2.686 4 6C4 9.314 6.686 12 10 12C13.314 12 16 9.314 16 6C16 2.686 13.314 0 10 0ZM10 8C8.898 8 8 7.102 8 6C8 4.898 8.898 4 10 4C11.102 4 12 4.898 12 6C12 7.102 11.102 8 10 8Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 4H20V8H40V4Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 18H20V22H40V18Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 32H20V36H40V32Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 28C6.686 28 4 30.686 4 34C4 37.314 6.686 40 10 40C13.314 40 16 37.314 16 34C16 30.686 13.314 28 10 28ZM10 36C8.898 36 8 35.102 8 34C8 32.898 8.898 32 10 32C11.102 32 12 32.898 12 34C12 35.102 11.102 36 10 36Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 26C13.3137 26 16 23.3137 16 20C16 16.6863 13.3137 14 10 14C6.68629 14 4 16.6863 4 20C4 23.3137 6.68629 26 10 26Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C6.686 0 4 2.686 4 6C4 9.314 6.686 12 10 12C13.314 12 16 9.314 16 6C16 2.686 13.314 0 10 0ZM10 8C8.898 8 8 7.102 8 6C8 4.898 8.898 4 10 4C11.102 4 12 4.898 12 6C12 7.102 11.102 8 10 8Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 4H20V8H40V4Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 18H20V22H40V18Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 32H20V36H40V32Z",
    fill: "#5DEE7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_36_30",
    x: 0,
    y: 0,
    width: 44,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_30",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleGreen);
export default __webpack_public_path__ + "static/media/multiple-green.90219037d68dfcaf5b58ae5436ec1471.svg";
export { ForwardRef as ReactComponent };